// extracted by mini-css-extract-plugin
export default {"suggestionsPanel":"SuggestionsPanel_suggestionsPanel__EhVUC","suggestion":"SuggestionsPanel_suggestion__ATeHZ"};